import React from "react";
import { connect } from "react-redux";
import { Alert as AlertPanel } from "react-bootstrap";

class Alert extends React.Component {
  render() {
    if (Object.keys(this.props.alert).length !== 0) {
      console.log(this.props.alert);
      return (
        <AlertPanel
          bsStyle={
            this.props.alert.type === "alert-error" ? "danger" : "warning"
          }
        >
          {this.props.alert.message}
        </AlertPanel>
      );
    }
    return "";
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  return {
    alert
  };
}
const connectedAlert = connect(mapStateToProps)(Alert);
export { connectedAlert as Alert };
